import { render, staticRenderFns } from "./LBtable.vue?vue&type=template&id=d326fe6a&"
import script from "./LBtable?vue&type=script&lang=ts&"
export * from "./LBtable?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports